module.exports = __webpack_public_path__ + "img/sy01.03bb87fe.svg";